module.exports = "../study/imgs/maps/Kanagawa/GWQ8/Climate/AnnualMaximumDailyPrecipitation/Kanagawa_AnnualMaximumDailyPrecipitation_MRI_RCP85_End.png";